

export default {
  props: {
    place: Object,
  },
};
